module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/discipline/discipline.component.html
// module id = ./src/app/Pages/manage/discipline/discipline.component.html
// module chunks = main